// extracted by mini-css-extract-plugin
module.exports = {"registerLayout":"register_registerLayout__HV__I","registerLayoutContainer":"register_registerLayoutContainer__BNCYG"};